<template>
  <div>
    <MatterPage v-if="!isPaneView"
                :active-tab="activePageTab"/>
    <MatterPane v-else
                :openOrigin="openOrigin"
                :active-tab="activeMobileTab"/>

    <Nesting v-if="nestingDialogOpen"
             @close="closeNestingDialog"
             :origin-client-uid="currContact.uid"
             :origin-client-email="currContact.email"
             :matter="matter"/>
  </div>
</template>

<script>
import MatterPage from "./MatterPage";
import MatterPane from "./MatterPane";
import Nesting from "@/modules/matters/components/Nesting/Nesting";
import {mapGetters} from "vuex";

export default {
  name: 'Matter',
  components: {MatterPane, MatterPage, Nesting},
  props: {
    uid: {
      type: String,
      required: true
    },
    mobileView: {
      type: Boolean,
      required: true
    },
    paneView: {
      type: Boolean,
      required: true
    },
    tab: {
      type: String
    },
    openOrigin: {
      type: String
    }
  },
  data() {
    return {
      nestingDialogOpen: false,
      isFetchNeeded: false
    }
  },
  async created() {
    this.closeNestingDialog();
    this.$frontageApi.listen('fetch-matter', this.fetchMatter);
    this.$frontageApi.listen('fetch-contact-details', this.fetchMatterData);
    this.$frontageApi.listen('show-nesting-dialog', this.openNestingDialog);
    if(this.openOrigin) {
      this.$store.commit('setAngularOrigin', this.openOrigin);
    }
    if (!this.matter || this.matter.uid !== this.uid || this.shouldReloadMatter) {
      await this.updateMatter();
    } else {
      this.$frontageApi.send('matter_action', {action: 'set_matter', matter: this.matter});
    }
  },
  watch: {
    uid: function() {
      this.updateMatter()
    }
  },
  methods: {
    async updateMatter() {
      !!this.matter && this.resetMatter();
      await this.fetchMatterData();
      this.$frontageApi.send('matter_action', {action: 'set_matter', matter: this.matter});
    },
    openNestingDialog() {
      this.nestingDialogOpen = true
    },
    closeNestingDialog() {
      this.nestingDialogOpen = false
    },
    resetMatter() {
      this.$store.dispatch({type: 'mattersModule/resetState'});
    },
    async fetchMatter() {
      await this.$store.dispatch({type: 'mattersModule/fetchMatter', payload: {matterUid: this.$route.params.uid}});
      this.$frontageApi.send('matter_action', {action: 'set_matter', matter: this.matter});
    },
    async fetchMatterData() {
      await this.$store.dispatch({type: 'mattersModule/fetchMatterData', payload: {matterUid: this.uid || this.$route.params.uid}});
    }
  },
  computed: {
    ...mapGetters('mattersModule', ['matter', 'currContact', 'activeMatterTab', 'shouldReloadMatter']),
    isPaneView() {
      return this.paneView || this.mobileView
    },
    activeMobileTab() {
      return this.tab || parseInt(sessionStorage.getItem('activeMatterTabMobile')) || 0;
    },
    activePageTab() {
      return this.tab || this.activeMatterTab || 'conversation';
    }
  },
  destroyed() {
    this.$frontageApi.remove('fetch-matter', this.fetchMatter);
    this.$frontageApi.remove('fetch-contact-details', this.fetchMatterData);
    this.$frontageApi.remove('show-nesting-dialog', this.openNestingDialog);
  }
}
</script>

<style lang="scss" scoped>

</style>
